import { MARK_DEV_CHANGE, RESET_CHANGE_FLAG } from "../actions/DevForm";

type State = {
   isAnyChange: boolean;
};

const initialState: State = {
   isAnyChange: false,
};

const devForm = (state: State = initialState, action): State => {
   switch (action.type) {
      case MARK_DEV_CHANGE:
         return { ...state, isAnyChange: true };
      case RESET_CHANGE_FLAG:
         return { ...state, isAnyChange: false };
      default:
         return state;
   }
};

export default devForm;
